import React, { Component } from 'react'
import { TableCell, TableRow, Button } from "@mui/material";
import { Col, Container, Modal, Row, Form } from 'react-bootstrap';
import ReactToPrint from 'react-to-print';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import axios from "axios";
import PhoneClinicGrid from '../../Components/PhoneClinicGrid';
import RowActions from '../../Components/PhoneClinicGrid/RowActions';
import { moneyCell, partyLabel } from '../../helper';
import StatusChip from './shared/StatusChip';
import Bardcode from '../../Components/JobForm/Bardcode';

import AmountInput from '../../Components/AmountInput';
import SectionHeader from './shared/SectionHeader';
class WarehouseDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            InventoryList: [],
            PC_WARE_ID: localStorage.getItem('PC_GRP_ATT'),

            IMEI_SEARCH: "",
            showModal: false,
            showData: {},

            purchaseData: {},
            saleData: {},

        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { IMEI_SEARCH, searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getInventory(IMEI_SEARCH, searchGridData, totalRecordsPerPage.value, paginationValue);
    // }

    async getInventory(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_WARE_ID: this.state.PC_WARE_ID,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset,
        };

        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/WarehouseModule/PCGetDeviceInventory.php`, formData);
        let serviceData = getAllInventory.data
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            pagination.totalItems = parseInt(serviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ InventoryList })
        this.props.toggleLoader(false)

    }

    async handleOpenModal(index) {
        let { InventoryList } = this.state;
        let showData, purchaseData, saleData = {}

        showData = InventoryList[index]

        console.log('showData', showData)

        if (showData.ItemStatus === "Sold") {
            let returnRecord = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/WarehouseModule/deviceRecord.php`, {
                imei: showData.ItemIMEI
            });

            console.log('returnRecord', returnRecord)
            if (returnRecord.data.data && returnRecord.data.data.length > 0) {
                let data = returnRecord.data.data;
                saleData = {
                    'SALE_WEEK': data[0].PC_WHS_WEEK,
                    'SALE_TO': data[0].SaleTO + " (" + data[0].PC_WHS_TOTYPE + ")",
                    'SALE_DATE': data[0].PC_WHS_DATE
                }
            }
        }
        purchaseData = {
            'PUR_INV_WEEK': showData.PUR_INV_WEEK,
            'PUR_FROM': showData.PUR_INV_TO + " (" + showData.PUR_INV_TOTYPE + ")",
            'PUR_DATE': showData.PUR_INV_DATE
        }

        this.setState({ showModal: true, showData, purchaseData, saleData })
    }

    render() {
        let { showData, purchaseData, saleData } = this.state;
        return (
            <Container>
                <PhoneClinicGrid
                    title="DEVICE"

                    isEditable={true}
                    ref={this.gridRef}
                    getData={this.getInventory.bind(this)}

                    tableHeadData={[

                        { label: "TYPE", isHidden: false },

                        { label: "BRAND", isHidden: false },

                        { label: "DEVICE", isHidden: false },

                        { label: "IMEI", isHidden: false },

                        { label: "PURCHASE FROM", isHidden: false },

                        { label: "BUY RATE", isHidden: false, align: 'right' },

                        { label: "SALE RATE", isHidden: false, align: 'right' },

                        { label: "STATUS", isHidden: false },
                    ]}
                >

                    {this.state.InventoryList.map((service, idx) => (
                        <TableRow
                            key={idx}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            <TableCell>{service.ItemType}</TableCell>
                            <TableCell>{service.ItemBrand}</TableCell>
                            <TableCell>{service.ItemName}</TableCell>
                            <TableCell>{service.ItemIMEI}</TableCell>
                            <TableCell>{partyLabel(service.PUR_INV_TO, service.PUR_INV_TOTYPE)}</TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.ItemRate)}</strong></TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.ItemSellRate)}</strong></TableCell>
                            <TableCell><StatusChip label={service.ItemStatus} /></TableCell>
                            <TableCell align='center'>
                                <RowActions actions={[
                                    { type: 'edit', onClick: this.handleOpenModal.bind(this, idx) },
                                ]} />
                            </TableCell>
                        </TableRow>
                    ))}

                </PhoneClinicGrid>
                <Modal
                    show={this.state.showModal}
                    onHide={() => { this.setState({ showModal: false }) }}
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Device Detail
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className='p-2' >
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Type</Form.Label>
                                    <Form.Control
                                        name={"ItemType"}
                                        disabled
                                       
                                        defaultValue={showData['ItemType']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <Form.Control
                                        name={"ItemBrand"}
                                        disabled
                                       
                                        defaultValue={showData['ItemBrand']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Item</Form.Label>
                                    <Form.Control
                                        name={"ItemName"}
                                        disabled
                                       
                                        defaultValue={showData['ItemName']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        name={"ItemStatus"}
                                        disabled
                                        defaultValue={showData["ItemStatus"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>IMEI No / Barcode</Form.Label>
                                    <Form.Control
                                        name={"ItemIMEI"}
                                        disabled
                                        defaultValue={showData["ItemIMEI"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        name={"ItemDesc"}
                                        disabled
                                        defaultValue={showData["ItemDesc"]}
                                       
                                        type={"textarea"}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Label>Barcode IMEI</Form.Label>
                                <div ref={el => (this.printLabel = el)} >
                                    <Bardcode
                                        value={showData["ItemIMEI"]}
                                        width={this.state.width}
                                        height={this.state.height}
                                        displayValue={this.state.displayValue}
                                        text={this.state.text}
                                        fontOptions={this.state.fontOptions}
                                        font={this.state.font}
                                        textAlign={this.state.textAlign}
                                        textPosition={this.state.textPosition}
                                        textMargin={this.state.textMargin}
                                        fontSize={this.state.fontSize}
                                        background={this.state.background}
                                        lineColor={this.state.lineColor}
                                        margin={this.state.margin}
                                        marginTop={this.state.marginTop}
                                        marginBottom={this.state.marginBottom}
                                        marginLeft={this.state.marginLeft}
                                        marginRight={this.state.marginRight}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <SectionHeader title="Purchase Record" style={{ marginTop: 8 }} />
                            </Col>
                        </Row>
                        <Row className='p-2' >
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }} >
                                        <span>Week</span>
                                        <span>
                                            {/* {shopPaymentDays.length > 0 ? `(${shopPaymentDays[0]['DateAndDay']} - ${shopPaymentDays[6]['DateAndDay']})` : ``} */}
                                        </span>
                                    </Form.Label>
                                    <WeekRangeSelect
                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        disabled={true}
                                        value={purchaseData['PUR_INV_WEEK']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Purchase From</Form.Label>
                                    <Form.Control
                                        disabled
                                       
                                        defaultValue={purchaseData['PUR_FROM']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        disabled
                                       
                                        defaultValue={purchaseData['PUR_DATE']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Purchase Rate</Form.Label>
                                    <AmountInput
                                        disabled
                                        defaultValue={showData["ItemRate"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <SectionHeader title="Sell Record" style={{ marginTop: 8 }} />
                            </Col>
                        </Row>
                        <Row className='p-2' >
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }} >
                                        <span>Week</span>
                                        <span>
                                            {/* {shopPaymentDays.length > 0 ? `(${shopPaymentDays[0]['DateAndDay']} - ${shopPaymentDays[6]['DateAndDay']})` : ``} */}
                                        </span>
                                    </Form.Label>
                                    <WeekRangeSelect
                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        disabled={true}
                                        value={saleData['SALE_WEEK']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Sale To</Form.Label>
                                    <Form.Control
                                        disabled
                                       
                                        defaultValue={saleData['SALE_TO']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        disabled
                                       
                                        defaultValue={saleData['SALE_DATE']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Sell Rate</Form.Label>
                                    <AmountInput
                                        disabled
                                        defaultValue={showData["ItemSellRate"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactToPrint
                            trigger={() => { return <Button>Print IMEI</Button>; }}
                            content={() => this.printLabel}
                        />
                    </Modal.Footer>
                </Modal>
            </Container >
        );
    }
}

export default WarehouseDevice;